type ValueProps = {
  title: string;
  description: string;
  icon: string;
};

const Value = ({ title, description, icon }: ValueProps) => (
  <div className="card" data-testid="value">
    {icon && <i className={`fal ${icon} fal--card-icon`} />}
    <h3 className="card__title">{title}</h3>
    <p>{description}</p>
  </div>
);

export default Value;
